import { InjectionToken } from '@angular/core';
import { createAuthClient } from 'better-auth/client';
import { adminClient, twoFactorClient } from 'better-auth/client/plugins';
import { environment } from '../../../environments/environment';

export const authClient = createAuthClient({
  baseURL: environment.apiUrl,
  plugins: [adminClient(), twoFactorClient()],
});

export const BETTER_AUTH_CLIENT = new InjectionToken<typeof authClient>('BETTER_AUTH_CLIENT', {
  providedIn: 'root',
  factory: () => authClient,
});
